import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
// import { useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';

// ApiSubHeader
const ApiSubHeader = (props) => {

  let dispatch = useNavigate();
  let [pathname, setPathname] = useState('');

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [window.location.pathname]);

  let selectedColor = '#000000'

  return (
    <div style={{
      paddingTop: 20,
      paddingBottom: 20,
    }}>
      <Container>

        <Row style={{
          fontSize: 15,
        }}>

          <Col md="12" xs="12" style={{
            textAlign: 'right',
          }}>

            <Link to="/api_usage" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/api_usage' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>API使用量</Link>

            <Link to="/api_token_manager" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/api_token_manager' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>トークン管理</Link>

            <Link to="/api_dict_manager" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/api_dict_manager' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>辞書管理</Link>

            {/*<Link to="/audio_editor" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/audio_editor' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>ブラウザ文字起こし</Link>*/}

            <Link to="/api_aspid_top" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/api_aspid_top' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>ASP管理</Link>


            {/*<Link to="/api_monitoring_words" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/api_monitoring_words' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>モニタリングワードの管理</Link>*/}

            {/*<Link to="/api_models" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/api_models' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>利用可能モデル</Link>*/}

            {/*<Link to="/api_server_manager" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname.indexOf('api_restart') !== -1 ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>サーバー管理</Link>*/}

          </Col>
        </Row>

      </Container>
    </div>
  )
}

export default ApiSubHeader
